import { createRoot } from 'react-dom/client';
import React from "react";
import {Provider} from "react-redux";
import {CookiesHOC} from "../react_components/dialogs/cookies";

export const CookiesDialogView = App.Views.BaseView.extend({
    initialize: function(options) {
        this.root = createRoot(this.el);
        this.store = options.store;
    },

    render: function () {
        this.root.render(
            <Provider store={this.store}>
                <CookiesHOC />
            </Provider>
        );
        return this;
    },

    remove: function () {
        this.root.unmount();
        Backbone.View.prototype.remove.call(this);
    }
});
